import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '@/contexts/AuthContext';
import { useMyStoresQuery } from '@/hooks/queries/useMyStoresQuery';
import { setAnalyticsUser } from '@/lib/analytics';

export function AnalyticsIdentity() {
  const { user } = useAuthContext();
  const { i18n } = useTranslation();
  const { data: stores = [] } = useMyStoresQuery(user?.uid);
  const primaryStore = stores[0];

  useEffect(() => {
    if (!user) {
      setAnalyticsUser(null);
      return;
    }
    setAnalyticsUser(user.uid, {
      gym_slug: primaryStore?.slug ?? 'none',
      store_id: primaryStore?.id ?? 'none',
      role: 'owner',
      locale: i18n.language || 'en',
    });
  }, [user, primaryStore?.id, primaryStore?.slug, i18n.language]);

  return null;
}
